import React from "react";
import { Slider } from "@mui/material";

interface ByzTrackBarProps {
  maxValue: number;
  value: number;
  step?: number;
  onChange: (value: number) => void;
  sx?: object;
}

function ByzTrackBar({
  maxValue,
  value,
  step = 1,
  onChange,
  sx,
}: ByzTrackBarProps) {
  const marks = Array.from({ length: maxValue + 1 }, (_, i) => ({
    value: i,
    label: i.toString(),
  }));

  const handleChange = (_event: Event, newValue: number | number[]) => {
    onChange(newValue as number);
  };

  return (
    <Slider
      aria-label="track-bar"
      value={value}
      onChange={handleChange}
      step={step}
      marks={marks}
      min={0}
      max={maxValue}
      valueLabelDisplay="on"
      sx={sx}
    />
  );
}

export default ByzTrackBar;
